import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authed = axios.create({ baseURL: API, withCredentials: true });

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const api = {
  list: (collection, params) => axios.get(`${API}/content/${collection}`, { params }).then(r => r.data),
  get: (collection, slug) => axios.get(`${API}/content/${collection}/${slug}`).then(r => r.data),
  enquire: (payload) => axios.post(`${API}/enquiries`, payload).then(r => r.data),
  partner: (payload) => axios.post(`${API}/partnerships`, payload).then(r => r.data),
  subscribe: (email) => axios.post(`${API}/newsletter`, { email }).then(r => r.data),
  login: (email, password) => authed.post("/auth/login", { email, password }).then(r => r.data),
  logout: () => authed.post("/auth/logout").then(r => r.data),
  me: () => authed.get("/auth/me").then(r => r.data),
  adminList: (collection) => authed.get(`/admin/${collection}`).then(r => r.data),
  adminCreate: (collection, payload) => authed.post(`/admin/${collection}`, payload).then(r => r.data),
  adminUpdate: (collection, id, payload) => authed.put(`/admin/${collection}/${id}`, payload).then(r => r.data),
  adminDelete: (collection, id) => authed.delete(`/admin/${collection}/${id}`).then(r => r.data),
};

export const WHATSAPP_URL = (text) =>
  `https://wa.me/916281128057?text=${encodeURIComponent(text || "Hi Vrova, I'd like to know more about your immersive experiences.")}`;
